import { render, staticRenderFns } from "./public-treatments-filter.vue?vue&type=template&id=2a5e02e6&"
import script from "./public-treatments-filter.vue?vue&type=script&lang=ts&"
export * from "./public-treatments-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports